<template>
  <div>
    <a-form layout="inline" :model="searchForm" style="margin-bottom:16px;" labelAlign="right" :labelCol="{flex: '90px'}">
      <div class="search-grid">
        <a-form-item label="用户名称"><a-input v-model:value="searchForm.username" placeholder="请输入用户名" /></a-form-item>
        <a-form-item label="用户ID"><a-input v-model:value="searchForm.userId" placeholder="请输入用户ID" /></a-form-item>
        <a-form-item label="登录地址"><a-input v-model:value="searchForm.loginAddr" placeholder="请输入登录地址" /></a-form-item>
        <a-form-item label="登录ip地址"><a-input v-model:value="searchForm.loginIp" placeholder="请输入登录ip地址" /></a-form-item>
        <a-form-item label="登录时间"><a-range-picker v-model:value="searchForm.loginTime" style="width:260px" /></a-form-item>
        <a-form-item label="应用code"><a-input v-model:value="searchForm.appCode" placeholder="请输入登录应用code" /></a-form-item>
        <a-form-item style="grid-column:span 2;display:flex;align-items:center;">
          <a-button type="primary" @click="handleSearch">查询</a-button>
          <a-button style="margin-left:8px" @click="handleReset">重置</a-button>
        </a-form-item>
      </div>
    </a-form>
    <a-table :columns="columns" :data-source="logList" row-key="id" :pagination="{pageSize:5}" />
  </div>
</template>
<style scoped>
.search-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px 16px;
  align-items: center;
}
</style>
<script setup>
import { ref } from 'vue';
const searchForm = ref({ username: '', userId: '', loginAddr: '', loginIp: '', loginTime: [], appCode: '' });
const columns = [
  { title: '登录时间', dataIndex: 'loginTime', key: 'loginTime' },
  { title: '用户名', dataIndex: 'username', key: 'username' },
  { title: '用户ID', dataIndex: 'userId', key: 'userId' },
  { title: '登录地址', dataIndex: 'loginAddr', key: 'loginAddr' },
  { title: '登录浏览器类型', dataIndex: 'browser', key: 'browser' },
  { title: '登录IP地址', dataIndex: 'loginIp', key: 'loginIp' },
  { title: '登录状态', dataIndex: 'status', key: 'status' },
  { title: '登录应用code', dataIndex: 'appCode', key: 'appCode' }
];
const logList = ref([
  { id: 1, loginTime: '2025-05-06 09:35', username: 'administrator', userId: '1740358057038188544', loginAddr: 'Edge', browser: 'Edge', loginIp: '172.20.0.1', status: '登录成功', appCode: 'core' },
  { id: 2, loginTime: '2025-05-05 09:55', username: 'administrator', userId: '1740358057038188544', loginAddr: 'Edge', browser: 'Edge', loginIp: '172.20.0.1', status: '登录成功', appCode: 'core' },
  { id: 3, loginTime: '2025-05-04 22:27', username: 'administrator', userId: '1740358057038188544', loginAddr: 'Edge', browser: 'Edge', loginIp: '172.20.0.1', status: '登录成功', appCode: 'core' },
  { id: 4, loginTime: '2025-05-04 22:27', username: 'administrator', userId: '0', loginAddr: 'Edge', browser: 'Edge', loginIp: '172.20.0.1', status: '验证码错误', appCode: 'core' },
  { id: 5, loginTime: '2025-05-02 11:37', username: 'administrator', userId: '1740358057038188544', loginAddr: 'Edge', browser: 'Edge', loginIp: '172.20.0.1', status: '登录成功', appCode: 'core' }
]);
function handleSearch() { /* 可根据searchForm过滤logList */ }
function handleReset() { searchForm.value = { username: '', userId: '', loginAddr: '', loginIp: '', loginTime: [], appCode: '' }; }
</script>